import axios from 'axios';

const getStopSaleSSC = (token: string, domain: string, vin: string) => {
  return axios.get(`${domain}/stopSale/ssc/${vin}`, {
    headers : { Authorization: token },
  });
};

export default getStopSaleSSC;
